import Swal from 'sweetalert2';
import './swal.scss'
import withReactContent from 'sweetalert2-react-content';
const swal = withReactContent(Swal);

export default swal;